<template>
  <div> <el-card class="card" :body-style="{ padding: '5px' }">
      <van-cell-group inset style="margin:0 0 5px 0">
        <van-collapse v-model="activeNames">
          <van-collapse-item title="测点名称" name="1">
            {{ wxcW_WXCWSensor.sensorName }}</van-collapse-item>
        </van-collapse>
        <van-collapse v-model="activeNames">
          <van-collapse-item title="前一天" name="2">
            {{ meiTianBaoJing.prev }}</van-collapse-item>
        </van-collapse>
        <van-cell title="平均温度(℃)" title-class="font" value-class="fontsize">{{ meiTianBaoJing.prevTemperature }}</van-cell>
        <van-collapse v-model="activeNames">
          <van-collapse-item title="后一天" name="3">
            {{ meiTianBaoJing.next }}</van-collapse-item>
        </van-collapse>
        <van-cell title="平均温度(℃)" title-class="font" value-class="fontsize">{{ meiTianBaoJing.nextTemperature }}</van-cell>
        <van-cell title="每天降温(℃)" title-class="font" value-class="fontsize">{{ meiTianBaoJing.meiTianJiangWen }}</van-cell>
      </van-cell-group>
      <el-row style="margin-top: 5px;">
        <van-cell title="报警时间">{{ meiTianBaoJing.createTime }}</van-cell>
      </el-row>
    </el-card></div>
</template>


<script>
import Vue from "vue";
import Vant from "vant";
import "vant/lib/index.css";
import "@/assets/css/digital.css";
Vue.use(Vant);
export default {
  data() {
    return {
      meiTianBaoJing: {},
      wxcW_WXCWSensor: {},
      activeNames: ["1", "2", "3"],
    };
  },
  methods: {
    getMeiTianBaoJing() {
      let that = this;
      that.axios
        .post("WXCW81/GetMeiTianBaoJingById", {
          onlyInt: that.$route.query.id,
        })
        .then((response) => {
          that.meiTianBaoJing = response.data.data;
          that.wxcW_WXCWSensor = response.data.data.wxcW_WXCWSensor;
        });
    },
  },
  mounted() {
    document.title = "每天报警";
    let that = this;
    that.getMeiTianBaoJing();
  },
};
</script>

<style scoped>
.card {
  background-color: #409eff;
}
.font {
  font-size: 1em;
}
.fontsize {
  font-size: 1.2em;
  color: red;
}
</style>